import React, { useState } from 'react';
import { Form, Row, Col, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './MerchantSelect.module.scss';

const MerchantSelect = ({
  merchants,
  selectedMerchants,
  onMerchantSelect,
  loading,
  validated,
  required = false,
  label = 'Merchants',
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  const filtered = React.useMemo(() => {
    if (!Array.isArray(merchants)) return [];
    const q = query.trim().toLowerCase();
    if (!q) return merchants;
    return merchants.filter((m) =>
      String(m.name || m.merchantName || '')
        .toLowerCase()
        .includes(q)
    );
  }, [merchants, query]);

  const isSelected = (id) => selectedMerchants.includes(id);

  const toggleMerchant = (id) => {
    if (isSelected(id)) {
      onMerchantSelect(selectedMerchants.filter((mId) => mId !== id));
    } else {
      onMerchantSelect([...selectedMerchants, id]);
    }
  };

  const removeMerchant = (id) => {
    onMerchantSelect(selectedMerchants.filter((mId) => mId !== id));
  };

  const selectedList = React.useMemo(() => {
    if (!Array.isArray(merchants)) return [];
    return merchants.filter((m) => selectedMerchants.includes(m.id));
  }, [merchants, selectedMerchants]);

  const selectedPreview =
    selectedList.length === 0
      ? loading
        ? 'Loading merchants...'
        : 'Select merchants'
      : `${selectedList.length} merchants selected`;

  return (
    <Form.Group as={Row} className={styles.formGroup}>
      <Form.Label column sm={3}>
        {label} {required && <span className='text-danger'>*</span>}
      </Form.Label>
      <Col sm={9}>
        <Dropdown
          show={open}
          onToggle={(isOpen) => setOpen(isOpen)}
          autoClose='outside'
        >
          <Dropdown.Toggle
            variant='light'
            className={`form-select text-start ${styles.noCaret}`}
            id='merchant-multiselect'
            disabled={loading}
          >
            {selectedPreview}
          </Dropdown.Toggle>

          <Dropdown.Menu className={styles.dropdownMenu}>
            <div className={styles.searchContainer}>
              <Form.Control
                size='sm'
                type='text'
                placeholder='Search merchants...'
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                autoFocus
              />
            </div>

            <div className={styles.scrollableMenu}>
              {filtered.length === 0 && (
                <div className={styles.noMatches}>No matches</div>
              )}
              {filtered.map((m) => (
                <Dropdown.Item
                  key={m.id}
                  active={isSelected(m.id)}
                  onClick={() => toggleMerchant(m.id)}
                >
                  {m.name || m.merchantName}
                </Dropdown.Item>
              ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>

        {selectedList.length > 0 && (
          <div className={styles.selectedTags}>
            {selectedList.map((m) => (
              <div key={m.id || m._id} className={styles.tag}>
                <span>{m.name || m.merchantName}</span>
                <button
                  className={styles.removeButton}
                  onClick={() => removeMerchant(m.id)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            ))}
          </div>
        )}

        {validated && selectedList.length === 0 && (
          <div className={styles.validationError}>
            Please select at least one merchant.
          </div>
        )}
      </Col>
    </Form.Group>
  );
};

export default MerchantSelect;
